module.exports = __webpack_public_path__ + "static/media/Tormund Giantsbane.abd7d403.jpg";